export type RWCFeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

/** Keys of the app.config.js FEATURES section */
export const FEATURE_FLAGS = {
    renameParticipant: 'RENAME_PARTICIPANT',
    renameParticipantsWR: 'RENAME_PARTICIPANTS_WR',
    videoTileMute: 'VIDEO_TILE_MUTE',
    videoTileChat: 'VIDEO_TILE_CHAT',
    modernVideoTile: 'MODERN_VIDEO_TILE',
    sequoiaAlert: 'SEQUOIA_ALERT',
    useVFSJoin: 'USE_VFS_JOIN',
    allowAudioRedInMainPC: 'ALLOW_AUDIO_RED_MAIN_PC',
    breakoutRooms: 'BREAKOUT_ROOMS',
    breakoutRoomsTimers: 'BREAKOUT_ROOMS_TIMERS',
    allowModeratorsManageBreakoutRooms: 'ALLOW_MODERATORS_MANAGE_BREAKOUT_ROOMS',
    allowSplitLayoutApply: 'ALLOW_SPLIT_LAYOUT_APPLY',
    brandInformation: 'BRAND_INFORMATION',
    customElectronSharing: 'CUSTOM_ELECTRON_SHARING',
    closedCaptions: 'CLOSED_CAPTIONS',
    ccLtTranslation: 'CC_LT_TRANSLATION',
    ccLtTranscriptLanguages: 'CC_LT_TRANSCRIPT_LANGUAGES',
    ccLtTranslateLanguages: 'CC_LT_TRANSLATE_LANGUAGES',
    cpuAdaptationV2: 'CPU_ADAPTATION_V2',
    cpuVideoprocessingAdaptation: 'CPU_VIDEO_PROCESSING_ADAPTATION',
    edrAnalyticsReporting: 'EDR_ANALYTICS_REPORTING',
    watchdog: 'WATCHDOG',
    largeMeetingLimits: 'LARGE_MEETING_LIMITS',
    dynamicGalleryOption: 'DYNAMIC_GALLERY_OPTION',
    useRnnoiseOnly: 'USE_RNNOISE_ONLY',
    krispDenoiser: 'KRISP_DENOISER',
    krispAutoMode: 'KRISP_AUTO_MODE',
    webKrispAutoMode: 'WEB_KRISP_AUTO_MODE',
    krispWasm: 'KRISP_WASM',
    dsdkKrispApi: 'DSDK_KRISP_API',
    sharingConfirmation: 'SHARING_CONFIRMATION',
    transcript: 'TRANSCRIPT',
    virtualBackground: 'VIRTUAL_BACKGROUND',
    weatherman: 'WEATHERMAN',
    weathermanLayouts: 'WEATHERMAN_LAYOUTS',
    weathermanGlassBoard: 'WEATHERMAN_GLASS_BOARD',
    presentationModeSharingBarButton: 'PRESENTATION_MODE_SHARINGBAR_BUTTON',
    hasMeetingNotesApi: 'HAS_MN_API',
    multiLanguageSupport: 'MULTI_LANGUAGE_SUPPORT',
    useTemporalSimulcastReceive: 'V_USE_HALFFPS_RECEIVE',
    postMeetingRegenerateTranscript: 'POST_MEETING_REGENERATE_TRANSCRIPT',
    collaborativeNotesContentLimit: 'COLLABORATIVE_NOTES_CONTENT_LIMIT',
    collaborativeNotesMaxUsers: 'COLLABORATIVE_NOTES_MAX_PARTICIPANTS',
    cpuUtilizationReports: 'CPU_UTILIZATION_REPORTS',
    e2eeUseLocalOffset: 'V_E2EE_USE_LOCAL_OFFSET',
    e2eeClientConfig: 'E2EE_CLIENT_CONFIG',
    aecDump: 'AEC_DUMP',
    preferredSSCodecWebV2: 'PREFERRED_SS_CODEC_WEB_V2',
    preferredSSCodecDesktopV2: 'PREFERRED_SS_CODEC_DESKTOP_V2',
    preferredSSResolutionWeb: 'PREFERRED_SS_RESOLUTION_WEB',
    preferredSSResolutionDesktop: 'PREFERRED_SS_RESOLUTION_DESKTOP',
    preferredVideoCodecWeb: 'PREFERRED_VIDEO_CODEC_WEB',
    preferredVideoCodecDesktop: 'PREFERRED_VIDEO_CODEC_DESKTOP',
    preferredSSScalabilityModeWeb: 'PREFERRED_SS_SCALABILITY_MODE_WEB',
    preferredSSScalabilityModeDesktop: 'PREFERRED_SS_SCALABILITY_MODE_DESKTOP',
    maxE2EEMeetingCapacity: 'MAX_E2EE_MEETING_CAPACITY',
    whiteboard: 'WHITEBOARD',
    whiteboardHelpLink: 'WHITEBOARD_HELP_LINK',
    postMeetingWhiteboard: 'POST_MEETING_WHITEBOARD',
    whiteboardMaxUsers: 'WHITEBOARD_MAX_USERS',
    allowSSStreamInMainPC: 'ALLOW_SS_STREAM_IN_MAIN_PC',
    useSSH264MainSw: 'USE_SS_H264_MP_SW',
    disableDscp: 'DISABLE_DSCP',
    mediaCapturingReports: 'MEDIA_CAPTURING_REPORTS',
    builtinTooltips: 'BUILTIN_TOOLTIPS',
    useVideoProcessingFPSLimiter: 'USE_VIDEO_PROCESSING_FPS_LIMITER',
    inMeetingLanguageIdentification: 'IN_MEETING_LANGUAGE_IDENTIFICATION',
    mediaRing: 'MEDIA_RING',
    inMeetingTranslation: 'IN_MEETING_TRANSLATION',
    allowAnyoneToRecordSchedulingPMI: 'ALLOW_ANYONE_TO_RECORD_SCHEDULING_PMI',
    inMeetingAllowLiveTranscriptForEveryone: 'IN_MEETING_ALLOW_LIVE_TRANSCRIPT_FOR_EVERYONE',
    allowAnyoneToTranscribeSchedulingPmi: 'ALLOW_ANYONE_TO_TRANSCRIBE_SCHEDULING_PMI',
    allowAutomaticallyShareRecording: 'AUTOMATICALLY_SHARE_RECORDING_WITH_COWORKERS',
    feedback: 'FEEDBACK',
    thirdPartyCameraLink: 'THIRD_PARTY_CAMERA_LINK',
    networkIssuesLink: 'NETWORK_ISSUES_LINK',
    nonRevocableMedia: 'NON_REVOCABLE_MEDIA_STREAM',
    reconnectOnMissingMedia: 'RECONNECT_ON_MISSING_MEDIA',
    // TODO RCV-83921
    postMeetingFeedback: 'POST_MEETING_FEEDBACK',
    postMeetingCollaborativeNotes: 'POST_MEETING_COLLABORATIVE_NOTES',
    postMeetingEditTranscript: 'POST_MEETING_EDIT_TRANSCRIPT',
    performanceAnalyticEvents: 'PERFORMANCE_ANALYTIC_EVENTS',
    enableBss: 'ENABLE_BSS',
    contactMeInRateQuality: 'CONTACT_ME_IN_RATE_QUALITY',
    mixpanel: 'MIXPANEL',
    postponeMixpanelEvents: 'POSTPONE_MIXPANEL_EVENTS',
    fallbackLocale: 'FALLBACK_LOCALE',
    useAdvancedAEC: 'USE_ADVANCED_AEC',
    nativeVideoProcessing: 'NATIVE_VIDEOPROCESSING',
    echoLeakDetection: 'ECHO_LEAK_DETECTION',
    settingAbout: 'SETTING_ABOUT',
    submitIdeasLink: 'SUBMIT_IDEAS_LINK',
    useMobileJoinFlow: 'USE_MOBILE_JOIN_FLOW',
    reportIssueSubcategory: 'REPORT_ISSUE_SUBCATEGORY',
    reportJupiterLogs: 'REPORT_JUPITER_LOGS',
    removeParticipantNameBackground: 'REMOVE_PARTICIPANT_NAME_BACKGROUND',
    trackRecoverySummary: 'TRACK_RECOVERY_SUMMARY',
    // feature flag to use screen-sharing-status alert for presenter and viewer
    screenSharingStatus: 'SCREEN_SHARING_STATUS',
    reconnectionHandling: 'RECONNECTION_HANDLING',
    sentryForGuests: 'SENTRY_FOR_GUESTS',
    audioDeviceChoiceImprovements: 'AUDIO_DEVICE_CHOICE_IMPROVEMENTS',
    joinModalCloseButtonRefactoring: 'JOIN_MODAL_CLOSE_BUTTON_REFACTORING',
    autoAdjustSharingSplitter: 'AUTO_ADJUST_SHARING_SPLITTER',
    paViewerEditText: 'PA_VIEWER_EDIT_TEXT',
    autoEnableAnnotationsForTab: 'AUTO_ENABLE_ANNOTATIONS_FOR_TAB',
    paManagePermissions: 'PA_MANAGE_PERMISSIONS',
    joinFlowAnalytics: 'JOIN_FLOW_ANALYTICS',
    minimizeParticipantVideo: 'MINIMIZE_PARTICIPANT_VIDEO',
    showLastReceivedVideoFrame: 'SHOW_LAST_RECEIVED_VIDEO_FRAME',
    tempModeratorManageBr: 'TEMP_MODERATOR_MANAGE_BR',
    unifiedInviteParticipants: 'UNIFIED_INVITE_PARTICIPANTS',
    newVBGDefaultOptions: 'NEW_VBG_DEFAULT_OPTIONS',
    partitionHealth: 'PARTITION_HEALTH',
    aiGenerateBackground: 'AI_GENERATE_BACKGROUND',

    /**
     * preferences
     * their type or structure doesn't allow them to be simply calculated using
     * the featureFlagClient.getFlag method, or they require additional code to work.
     * use featureFlagClient.getRemoteFeatureFlagValue method, can get the pure flag value from remote(FFS)
     */
    developerMode: 'USE_DEVELOPER_MODE',
    rwcLoggerConfig: 'RWC_LOGGER_CONFIG',
    reportLogsForPeriod: 'REPORT_LOGS_FOR_PERIOD',
    reportJupiterLogsForPeriod: 'REPORT_JUPITER_LOGS_FOR_PERIOD',
    originTrial: 'ORIGIN_TRIAL',
    dispatchPerformanceReportInterval: 'DISPATCH_PERFORMANCE_REPORT_INTERVAL',
    federatedModules: 'FEDERATED_MODULES_CONFIG',
    krispProcessorOptions: 'V_KRISP_PROCESSOR_OPTIONS',
    videoProcessingFPSLimit: 'VIDEO_PROCESSING_FPS_LIMIT',
    advancedAECConfig: 'ADVANCED_AEC_CONFIG',
    advancedEchoLeakDetectionConfig: 'ADVANCED_ECHO_LEAK_DETECTION_CONFIG',
    persistentAnnotationsRestrictions: 'PERSISTENT_ANNOTATIONS_RESTRICTIONS',
    advancedAECAudioSharingConfig: 'ADVANCED_AEC_AUDIO_SHARING_CONFIG',
    disableInvisibleVideos: 'DISABLE_INVISIBLE_VIDEOS',
    warnOnMicSilence: 'WARN_ON_MIC_SILENCE',
    advancedAECAudioSharingConfigMac: 'ADVANCED_AEC_AUDIO_SHARING_CONFIG_MAC',
    glipApiExpRetry: 'GLIP_API_EXP_RETRY',
    krispBufferOverflow: 'KRISP_BUFFER_OVERFLOW',
    meetingQualityDetectConfig: 'MEETING_QUALITY_DETECT_CONFIG',
    mediaTrafficDetectorConfig: 'MEDIA_TRAFFIC_DETECTOR_CONFIG',
    useAbsCaptureTimeExtension: 'USE_ABS_CAPTURE_TIME_EXTENSION',
    usePamV3: 'USE_PAM_V3',

    // Desktop related feature flags
    webRTCTtialVP8PreallocImgBuffPool: 'WEBRTC_TRIAL_VP8_PREALLOCATED_ENCODED_IMAGE_BUFFER_POOL',
    webRTCTrialVP8ffmpegDecoder: 'WEBRTC_TRIAL_VP8_FFMPEG_DECODER',
    webRTCTrialBWEOptimization: 'WEBRTC_TRIAL_BWE_OPTIMIZATION',
    webRTCTrialInputAudioModeMonitor: 'WEBRTC_TRIAL_INPUT_AUDIO_MODE_MONITOR',
    webRTCTrialAudio2ndAgcMinMicLevel: 'WEBRTC_TRIAL_AUDIO_2ND_AGC_MIN_MIC_LEVEL',
    webrtcTrialVideoCodecAv1Config: 'WEBRTC_TRIAL_VIDEO_CODEC_AV1_CONFIG',
    webRTCTrialAudioOpusDred: 'WEBRTC_TRIAL_AUDIO_OPUS_DRED',
    webrtcTrialVideoEnableCalculatePsnr: 'WEBRTC_TRIAL_VIDEO_ENABLE_CALCULATE_PSNR',
    winRTCapturer: 'WINRT_CAPTURER',
    shareHighFPSVideo: 'SHARE_HIGH_FPS_VIDEO',
    persistentAnnotations: 'PERSISTENT_ANNOTATIONS',
    desktopSharingMedia: 'DESKTOP_SHARING_MEDIA',
    DSDKApi2: 'DSDK_API_2',
    DSDKProfilerEnabled: 'DSDK_PROFILER_ENABLED',
    DSDKProfilerUploadEdrEnabled: 'DSDK_PROFILER_UPLOAD_EDR_ENABLED',
    // Enables collection of screen-sharing launch timing metrics for both outbound and inbound flows.
    // https://wiki.ringcentral.com/pages/viewpage.action?spaceKey=VMT&title=Kibana+Observability+improve+-+Screen+Share+datatrack#KibanaObservabilityimproveScreenSharedatatrack-FeatureFlag
    VScreenShareDataTrack: 'V_SCREEN_SHARE_DATA_TRACK',
    cachingServiceWorkerEnabled: 'CACHING_SW_ENABLED',
    SFUConfig: 'SFU_CONFIG',
    reduceMaxVolumeApp: 'REDUCE_MAX_VOLUME_APP',
    reduceMaxVolumeWeb: 'REDUCE_MAX_VOLUME_WEB',
    reportIssueButtonPosition: 'REPORT_ISSUE_BUTTON_POSITION',
    audioVideoAlertBadNetwork: 'AUDIO_VIDEO_ALERT_BAD_NETWORK',
    compressEdrMessages: 'COMPRESS_EDR_MESSAGES',
    bweStatsReport: 'BWE_STATS_REPORT',
    autoHideMeetingControls: 'AUTO_HIDE_MEETING_CONTROLS',
    ss0hz: 'SS_0HZ',
    ssDefault15fps: 'SS_DEFAULT_15FPS',
    syncMeetingSettings: 'SYNC_MEETING_SETTINGS',
    syncMoreMeetingSettings: 'SYNC_MORE_SETTINGS',
    e2eeKrispAlwaysOn: 'E2EE_KRISP_ALWAYS_ON',
    nonMixAudioKrispAlwaysOn: 'NON_MIX_AUDIO_KRISP_ALWAYS_ON',
    echoLeakDetectionSenderConfig: 'ECHO_LEAK_DETECTION_SENDER_CONFIG',
    desktopFloatingPanelSetting: 'DESKTOP_FLOATING_PANEL_SETTING',
    SSPreloadLib: 'SS_PRELOAD_LIB',
    selfControlsMenuSimplification: 'SELF_CONTROLS_MENU_SIMPLIFICATION',
    mobileBrowserSpeakers: 'MOBILE_BROWSER_SPEAKERS',
    recordingForLiveTranscript: 'RECORDING_FOR_LIVE_TRANSCRIPT',
    lopPinDeprecated: 'LOP_PIN_DEPRECATED',
    rcRendererEvents: 'RC_RENDERER_EVENTS',
    enableFirstTimeRcvUserFlow: 'ENABLE_FIRST_TIME_RCV_USER_FLOW',
    hdVideoDefault: 'HD_VIDEO_DEFAULT',
    useAudioDred: 'USE_AUDIO_DRED',
    useDredE2ee: 'USE_DRED_E2EE',
    audioMetrics: 'AUDIO_METRICS',
    rollbackWebAudioForIOS: 'ROLLBACK_WEBAUDIO_FOR_IOS', // should be set in FFS in emergency case
    audioVideoPreview: 'AUDIO_VIDEO_PREVIEW',
    avpreviewPollingConfig: 'AVPREVIEW_POLLING_CONFIG',
    receiverSideVideoUpscaler: 'RECEIVER_SIDE_VIDEO_UPSCALER',
    improveParticipantIsolation: 'IMPROVE_PARTICIPANT_ISOLATION',
    screenSharingSpinnerDelay: 'SCREEN_SHARING_SPINNER_DELAY',
    rcvAiNotes: 'RCV_AI_NOTES',
    rcvAiNotesAutoTranslate: 'RCV_AI_NOTES_AUTO_TRANSLATE',
    pictureInPicture: 'PICTURE_IN_PICTURE',
    emojiNewPicker: 'EMOJI_NEW_PICKER',
    redirectRecordingLinkToJupiter: 'REDIRECT_RECORDING_LINK_TO_JUPITER',
    emojiBurstAnimation: 'EMOJI_BURST_ANIMATION',
    userpilotEnable: 'USERPILOT_ENABLE',
    turnOffSimultaneousRecordingAndNotes: 'TURN_OFF_SIMULTANEOUS_RECORDING_AND_NOTES',
    settingCalendarEnabled: 'SETTING_CALENDAR_ENABLED',
    settingDelegatesEnabled: 'SETTING_DELEGATES_ENABLED',
    settingPersonalMeetingEnabled: 'SETTING_PERSONAL_MEETING_ENABLED',
    settingProfileEnabled: 'SETTING_PROFILE_ENABLED',
    mutedWhenSpeaking: 'MUTED_WHEN_SPEAKING',
    ffsSnapshotReport: 'FFS_SNAPSHOT_REPORT',
    mixedAudioLipSync: 'MIXED_AUDIO_LIP_SYNC',
} as const;

/**
 * It is FORBIDDEN to modify this object
 */
const FFS_LEGACY_FLAGS = {
    [FEATURE_FLAGS.multiLanguageSupport]: 'v_mn_multi_language_support',
    [FEATURE_FLAGS.useTemporalSimulcastReceive]: 'v_use_halffps_receive',
    [FEATURE_FLAGS.e2eeUseLocalOffset]: 'v_e2ee_use_local_offset',
    [FEATURE_FLAGS.e2eeClientConfig]: 'e2ee_client_config',
    [FEATURE_FLAGS.krispProcessorOptions]: 'v_krisp_processor_options',
    [FEATURE_FLAGS.screenSharingStatus]: 'v_screensharing_status',
    [FEATURE_FLAGS.recordingForLiveTranscript]: 'v_start_rec_for_lt',
    [FEATURE_FLAGS.VScreenShareDataTrack]: 'v_screen_share_data_track',
    [FEATURE_FLAGS.whiteboardMaxUsers]: 'v_whiteboard_max_participants',
    [FEATURE_FLAGS.advancedAECAudioSharingConfig]: 'v_advanced_audio_sharing_config',
    [FEATURE_FLAGS.advancedAECAudioSharingConfigMac]: 'v_advanced_audio_sharing_config_mac',
    [FEATURE_FLAGS.cachingServiceWorkerEnabled]: 'v_caching_service_worker_enabled',
    [FEATURE_FLAGS.submitIdeasLink]: 'v_ideas_portal_url',
    [FEATURE_FLAGS.audioVideoAlertBadNetwork]: 'v_audio_video_alert_badnetwork',
    [FEATURE_FLAGS.syncMeetingSettings]: 'sync_meeting_settings',
    [FEATURE_FLAGS.lopPinDeprecated]: 'v_list_of_participants_pin_deprecated',
    [FEATURE_FLAGS.ccLtTranslation]: 'v_live_transcript_closed_captions_translation',
    [FEATURE_FLAGS.ccLtTranscriptLanguages]:
        'v_live_transcript_closed_captions_transcript_languages',
    [FEATURE_FLAGS.ccLtTranslateLanguages]: 'v_live_transcript_closed_captions_translate_languages',
};

export const FFS_FEATURE_FLAGS = Object.assign(
    Object.fromEntries(Object.values(FEATURE_FLAGS).map(v => [v, 'v_' + v.toLowerCase()])),
    FFS_LEGACY_FLAGS
);
